import {ApplicationDataState} from "./types";
import {createSlice} from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit';

export const initialState: ApplicationDataState = {
    needSelection: 'yes',
    testType: 'opt',
};

const slice = createSlice({
    name: 'applicationForm',
    initialState,
    reducers: {
        setCompanyName(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['companyName']>) {
            state.companyName = action.payload;
        },
        setAddress(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['address']>) {
            state.address = action.payload;
        },
        setPhone(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['phone']>) {
            state.phone = action.payload;
        },
        setEmail(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['email']>) {
            state.email = action.payload;
        },
        setTestObject(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['testObject']>) {
            state.testObject = action.payload;
        },
        setTestArea(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['testArea']>) {
            state.testArea = action.payload;
        },
        setFieldCount(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['fieldCount']>) {
            state.fieldCount = action.payload;
        },
        setSamplesCount(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['samplesCount']>) {
            state.samplesCount = action.payload;
        },
        setNeedSelection(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['needSelection']>) {
            state.needSelection = action.payload;
        },
        setTestType(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['testType']>) {
            state.testType = action.payload;
        },
        setExpectedDeadline(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['expectedDeadline']>) {
            state.expectedDeadline = action.payload;
        },
        setFreeSoilTestList(state: ApplicationDataState, action: PayloadAction<ApplicationDataState['freeSoilTestList']>) {
            state.freeSoilTestList = action.payload;
        },
    },
});

export const {actions, reducer} = slice;